/**
 * In this file use to contains the physician Module Dashboard screen UI and Logic
 **/
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import DevelopmentModal from "../modals/DevelopmentModal";
import VaccinationModal from "../modals/VaccinationModal";
import MedicalIssueModal from "../modals/MedicalIssueModal";
import AppointmentsModal from "../modals/AppointmentsModal";
import ApiService from "../../services/ApiService";
import {goBack,
  convertDOBtoAge,
  convertDOBtoMonth,
  formatMeasurement,
  convertS3privateToPublic,
  convertUTCtoLocal,
  getBrowserInfo,
  getMakeFromBrowser
} from "../../services/UtilsService";
import Pagination from "../components/Pagination";
import Filter from "../components/Filter";
import ChartModal from "../modals/ChartModal";
import MeasurementChart from "../modals/MeasurementChartModal";
import MessageModal from "../modals/MessageModal";
import AddMedicalInfoModal from "../modals/AddMedicalInfoModal";
import { useTranslation } from 'react-i18next';

function Dashboard(props) {
  //Intial state declaration
  const { t } = useTranslation();
  const [modal, setModal] = useState({});
  const [request, setRequest] = useState({
    page: 0,
    limit: 10,
    clinics: [],
    age_range: [],
    sort: "updated",
    showFutureAppointments: false
  });
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [clinicList, setClinicList] = useState({});
  const [isFilterOpen, setFilterOpen] = useState(false);
  const [message, setMessage] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const role = Number(localStorage.getItem('role'));
  const currentUrl = window.location.href;

  //Component Initialize function when the request value change
  useEffect(() => {
	  const fetchData = async () => {
		setIsLoading(true); 
		try {
		  var response = await ApiService.listFamilyMember(request);
		  if (response?.status === 200) {
			setData(response.data.data);
			setCount(response.data.count);
		  }
		}catch (error) {
        console.error('Error fetching family member:', error);
		} finally {
        setIsLoading(false); 
		}
	  };
	  fetchData();
  }, [request]);

  //Component Initialize function
  useEffect(() => {
    (async () => {
      var clinicResponse = await ApiService.getPhysicainClinics();
      if (clinicResponse?.status === 200) {
        setClinicList(clinicResponse?.data);
      }
      // To create device details
      const isDeviceDetailsSent = localStorage.getItem("deviceDetailsSent");
      if (!isDeviceDetailsSent && role === 2) {
        const browserInfo = getBrowserInfo();
        const deviceDetailsPayload = {
          deviceType: 3,
          make: getMakeFromBrowser(browserInfo.webBrowserType) || "Unknown",
          model: browserInfo.webBrowserType || "Unknown",
          os: browserInfo.OSVersion || "Unknown",
          version: browserInfo.webBrowserVersion || "Unknown"
        };
        try {
          await ApiService.createDeviceDetails(deviceDetailsPayload);
          localStorage.setItem("deviceDetailsSent", "true");
        } catch (err) {
          console.error("Device details API failed:", err);
        }
      }
    })();
  }, []);

  //To close message modal
  const closeMessage = () => {
    setMessage({});
  };

  /**
   * To handle pagination event
   * @data we pass the page number count
   **/
  const handlePaginate = (data) => {
    setRequest((req) => ({ ...req, page: data }));
  };

  //callback function
  const handleClose = () => setModal({});

  /**
   * To Fliter the Member list based on the Select clinics details
   * callback function for handleClinicChange
   * @e we get the event Details from the change function
   **/
  const handleClinicChange = (e) => {
    const { value, checked } = e.target;
    setRequest((request) => {
      if (checked) {
        return { ...request, clinics: [...request.clinics, value] };
      } else {
        return {
          ...request,
          clinics: request.clinics.filter((option) => option !== value),
        };
      }
    });
  };

  /**
   * To Fliter the Member list based on the Select Age Range details
   * callback function for handleAgeChange
   * @e we get the event Details from the change function
   **/
  const handleAgeChange = (e, item) => {
    const { value, checked } = e.target;
    setRequest((request) => {
      if (checked) {
        return { ...request, age_range: [...request.age_range, value] };
      } else {
        return {
          ...request,
          age_range: request.age_range.filter((option) => option !== value),
        };
      }
    });
  };

  /**
   * callback handleSidebarToggle
   * To open and close the Dashboard Fliter Opction
   **/
  const handleSidebarToggle = () => {
    setFilterOpen(!isFilterOpen);
  };

  /**
   * To close the Dashboard Fliter Opction with the cross mark button
   **/
  const handleDismiss = () => {
    setFilterOpen(false);
  };

  return (
    <main id={props.data === 'dashboard' && role === 4 ? '' : 'main'} className="main">
      {/*import DevelopmentModal*/}
      {Object.keys(modal).length !== 0 && modal.development && (
        <DevelopmentModal data={modal} handleClose={handleClose} />
      )}

      {/*import VaccinationModal*/}
      {Object.keys(modal).length !== 0 && modal.vaccination && (
        <VaccinationModal data={modal} handleClose={handleClose} />
      )}

      {/*import MedicalIssueModal*/}
      {Object.keys(modal).length !== 0 && modal.medication && (
        <MedicalIssueModal data={modal} handleClose={handleClose} />
      )}

      {/*import AppointmentsModal*/}
      {Object.keys(modal).length !== 0 && modal.appointment && (
        <AppointmentsModal data={modal} handleClose={handleClose} />
      )}

      {/*import ChartModal*/}
      {Object.keys(modal).length !== 0 && modal.chart && (
        <ChartModal data={modal} handleClose={handleClose} />
      )}

      {/*import MeasurementChart*/}
      {Object.keys(modal).length !== 0 && modal.measurement && (
        <MeasurementChart data={modal} handleClose={handleClose} />
      )}

      {/*MessageModal*/}
      {Object.keys(message).length !== 0 && (
        <MessageModal data={message} handleClose={closeMessage} />
      )}
	  
	  {/*AddMedicalInfoModal*/}
      {Object.keys(modal).length !== 0 && modal.addInfo && (
        <AddMedicalInfoModal data={modal} handleClose={handleClose} />
      )}

      {/*import Filter*/}
      {
        <Filter
          handleClinicChange={handleClinicChange}
          handleAgeChange={handleAgeChange}
          clinicList={clinicList}
          handleSidebarToggle={isFilterOpen}
          handleDismiss={handleDismiss}
        />
      }
      {props.data !== 'dashboard' && (
        <div className="pagetitle clearfix">
          {role === 4 ? (
            <>
            <div className="float-start">
            <h1>{t('sidebar.children')}</h1>
            <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/hospital/admin/dashboard">
                  {t('sidebar.home')}
                </Link>
              </li>
              <li className="breadcrumb-item active">{t('sidebar.children')}</li>
            </ol>
          </nav>
          </div>
          <div className="float-end mt-2 me-1">
					<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
				</div>
          </>
          ) : (
            <h1>{t('sidebar.dashboard')}</h1>
          )}
        </div>
      )}
      {/*Page Content Section*/}
      <section className="pagesection">
        {/*Search*/}
        <div className="row my-3">
          <div className="col-xxl-6 col-lg-6 d-flex">
            <div className="input-group input-group-sm me-2 w-50" style={{height:'0%'}}>
              <input
                type="text"
                onChange={(e) =>
                  setRequest((req) => ({
                    ...req,
                    search: e.target.value,
                    page: 0,
                  }))
                }
                className="form-control"
                placeholder={t('common.search')}
              />
              <button className={`btn ${role === 4 ? 'btn-tmAquaDgreen' : 'btn-tmBlue'}`} type="button">
                <i className="ri-search-line align-middle"></i>
              </button>
            </div>
            <button
              style={{ position: "relative", left: "2rem", height: window.location.href.includes("hospital/admin/dashboard") ? "2.25rem" : "100%" }}
              onClick={handleSidebarToggle}
              className={`btn btn-sm ${role === 4 ? 'btn-outline-tmAquaDgreen' : 'btn-outline-tmBlue'}`}
              type="button"
            >
              <i className="ri-filter-2-fill"></i>{" "}
              {t('common.filter')}
            </button>
          </div>
          <div className={`col-xxl-6 col-lg-6 ${
            role === 4 && currentUrl.includes("hospital/admin/dashboard")? 'd-flex justify-content-between align-items-center' : props.data !== 'dashboard' && currentUrl.includes("children") ?  'd-flex justify-content-end' : ''
          }`}>
          {/* Switch Button Implementation */}
          {role === 4 && props.data === 'dashboard' && (
            <div className="float-start me-3">
              <label className="form-check form-switch ms-3">
                <input
                  type="checkbox"
                  className={`form-check-input ${role === 4 ? 'hospitalAdminChecked' : ''}`}
                  checked={request.showFutureAppointments || false}
                  // onChange={() =>
                  //   setRequest((req) => ({
                  //     ...req,
                  //     showFutureAppointments: !req.showFutureAppointments,
                  //     // sort: req.showFutureAppointments ? 'created' : 'futureAppointments',
                  //   }))
                  // }
                  onClick={() =>
                    setRequest((req) => ({ ...req, showFutureAppointments: !req.showFutureAppointments }))
                  }
                />
                <span className="form-check-label" style={{fontWeight:'600'}}>
                  {t('common.viewByAppointment')}
                </span>
              </label>
            </div>
          )}
          
          {role === 4 && props.data === 'dashboard' && (
          <Link to={'/hospital/admin/children'} className="ms-3">
              <button type="button" className={`btn btn-sm ${role === 4 ? 'btn-tmAquaDgreen' : 'btn-tmBlue'} float-end`}>
						    <i className="ri-file-list-line  align-middle"></i> {t('common.viewAll')}
					    </button>
          </Link>
          )}

             {/* Dropdown for Sorting */}
            <div  className={`dropdown ${
              role === 4 ? 'ms-3' : 'float-end me-3'
            }`}>
              <a
                href="javascript;"
                className={`btn btn-sm ${role === 4 ? 'btn-outline-tmAquaDgreen' : 'btn-outline-tmBlue'} dropdown-toggle`}
                role="button"
                id="dropdownMenuLink"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {" "}
                {t('common.sort')}{" "}
              </a>

              <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <li
                  onClick={() =>
                    setRequest((req) => ({ ...req, sort: "created" }))
                  }
                >
                  <span
                    className={
                      request.sort === "created"
                        ? `dropdown-item ${role === 4 ? 'admin-dropdown-item' : ''} active`
                        : `dropdown-item ${role === 4 ? 'admin-dropdown-item' : ''}`
                    }
                  >
                    {" "}
                    {t('common.recentAdded')}
                  </span>
                </li>
                <li
                  onClick={() =>
                    setRequest((req) => ({ ...req, sort: "updated" }))
                  }
                >
                  <span
                    className={
                      request.sort === "updated"
                        ? `dropdown-item ${role === 4 ? 'admin-dropdown-item' : ''} active`
                        : `dropdown-item ${role === 4 ? 'admin-dropdown-item' : ''}`
                    }
                  >
                    {" "}
                    {t('common.recentUpdated')}
                  </span>
                </li>
              </ul>
            </div>
            {/* Add Children Button */}
            {role === 4 && props.data !== 'dashboard' && (
              <Link to={'/hospital/admin/add-children'} className="ms-3">
                <button type="button" className={`btn btn-sm ${role === 4 ? 'btn-outline-tmAquaDgreen' : 'btn-outline-tmBlue'} float-end`}>
                  <i className="ri-add-box-fill align-middle"></i> {t('profile.addChild')}
                </button>
              </Link>
            )}
          </div>
        </div>
        {/*End Search*/}

        {/*Table*/}
        <div className="row my-3">
          <div className="col-xxl-12">
            <div className={`table-responsive ${role === 4 ? 'admin-table-responsive' : ''}`}>
              <table className="table table-borderless theme-table">
                <thead>
                  <tr>
                    <th scope="col">{t('table.memberDetails')}</th>
                  {/*  <th scope="col" className="text-center">
                      {constantVariables.table.analytics}
                    </th> */}
                    {role === 4 && props.data === 'dashboard' && request?.showFutureAppointments && (
                       <th scope="col" className="text-center">
                       {t('modal.appointmentDate')}
                     </th>
                    )}
                    <th scope="col" className="text-center">
                      {t('table.weight')}
                    </th>
                    <th scope="col" className="text-center">
                      {t('common.deviceName')}
                    </th>
                    <th scope="col" className="text-center">
                      {t('table.height')}
                    </th>
                    <th scope="col" className="text-center">
                      {t('table.head')}
                    </th>
                    <th scope="col" className="text-center">
                      {t('table.bloodGroup')}
                    </th>
                    <th scope="col" className="text-center">
                      {t('table.description')}
                    </th>
                    {role !== 4 && <>
                      <th scope="col" className="text-center">
                      {t('table.add')}
                    </th>
                    </>} 
                    {/*<th scope="col" className="text-center">{constantVariables.table.temperature}</th>
								<th scope="col" className="text-center">{constantVariables.table.heartRate}</th>
								<th scope="col" className="text-center">{constantVariables.table.bloodGlucose}</th>*/}
                  </tr>
                </thead>
                <tbody>
                  {data &&
                    data.length !== 0 &&
                    data.map((item, i) => (
                      <tr
                        key={i}
                        className={item.gender === 0 ? "male" : "female"}
                      >
                        <td>
                          <div className="d-flex align-items-center ps-1z text-capitalize">
                            <div className="avtar-img">
                              <span className="rounded-circle">
                                {item?.photo === "default.png" ? (
                                  <img
                                    src="/assets/img/user-avatar.png"
                                    alt="UN"
                                  />
                                ) : (
                                  <img
                                    src={convertS3privateToPublic(item?.photo)}
                                    alt="UN"
                                  />
                                )}
                              </span>
                            </div>
                            <div className="ms-3">
                              {role===4 ? (<Link
                                to={"/hospital/admin/view-children/" + item?.id}
                              >
                                <h5 className="table-title fw-bold">
                                  {item.name}
                                </h5>
                              </Link>):(<Link
                                to={"/physician/member-profile/" + item?.id}
                              >
                                <h5 className="table-title fw-bold">
                                  {item.name}
                                </h5>
                              </Link>)}
                              <p className={`table-subtitle ${role === 4 ? 'admin-table-subtitle' : ''}`}>
                                <span>
                                  {item.gender === 0 ?  t('common.boy') :  t('common.girl')}
                                </span>{" "}
                                - {convertDOBtoAge(item.dob, t)}
                              </p>
                              <div className="icon-link">
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    setModal({
                                      development: true,
                                      id: item.id,
                                      parent: item.parent,
                                      name: item.name,
                                    })
                                  }
                                  className="me-1 text-tmGreen"
                                >
                                  <i
                                    className="fa-solid fa-chart-column"
                                    title={t('sidebar.development')}
                                  ></i>
                                </span>
                                <span
                                  style={{ cursor: "pointer" }}
                                  className={`me-1 ${role === 4 ? 'text-tmAquaDgreen' : 'text-tmBlue'}`}
                                  onClick={() =>
                                    setModal({
                                      vaccination: true,
                                      member: item.id,
                                      dob: convertDOBtoMonth(item.dob),
                                      name: item.name,
                                      parent: item.parent,
                                    })
                                  }
                                >
                                  <i
                                    className="fa-solid fa-syringe"
                                    title={t('sidebar.vaccination')}
                                  ></i>
                                </span>
                                <span
                                  style={{ cursor: "pointer" }}
                                  className="me-1 text-tmAquaGreen"
                                  onClick={() =>
                                    setModal({
                                      medication: true,
                                      member: item.id,
                                      name: item.name,
                                      parent: item.parent,
                                      dob: item.dob,
                                    })
                                  }
                                >
                                  <i
                                    className="fa-solid fa-hospital-user"
                                    title={t('sidebar.medicalIssues')}
                                  ></i>
                                </span>
                                <span
                                  style={{ cursor: "pointer" }}
                                  className="me-1 text-tmPurple"
                                >
                                  <i
                                    className="fa-regular fa-calendar-days"
                                    onClick={() =>
                                      setModal({
                                        appointment: true,
                                        member: item.id,
                                        name: item.name,
                                      })
                                    }
                                    title={t('sidebar.appointments')}
                                  ></i>
                                </span>
                                {role===4 && <>
                                  <span
                                  style={{ cursor: "pointer",fontSize: "12px"}}
                                  className="py-0 px-1 btn btn-xs btn-tmAquaGreen add-border-radius-0-2rem"
                                  onClick={() =>
                                    setModal({
                                      addInfo: true,
                                      member: item.id,
                                      name: item.name
                                    })
                                  }
                                  title={t('profile.addMedicalInfo')}
                                >
                                  <i
                                    className="ri-add-line align-middle"
                                  ></i>Add
                                </span>
                                </>}
                              </div>
                            </div>
                          </div>
                        </td>
                       {/*  <td className="text-center">
                          <span>
                            {item?.interactiontime
                              ? item.interactiontime
                              : "00:00:00"}
                          </span>
                        </td> */}

                        {role === 4 && props.data === 'dashboard' && request?.showFutureAppointments && (
                          <td className="text-center">
                            {item?.next_appointment_date ? convertUTCtoLocal(new Date(item.next_appointment_date).toUTCString()) : '--'}
                        </td>
                        )}

                        <td className="text-center">
                          <span
                            className={`table-link ${role === 4 ? 'admin-table-link' : ''}`}
                            onClick={() =>
                              setModal({
                                measurement: true,
                                member: item.id,
                                chartName: "Weight",
                                gender: item.gender,
                                parent: item.parent,
                                dob: item?.dob,
                                name: item.name,
                              })
                            }
                          >
                            {item?.latest_weight
                              ? formatMeasurement(item.latest_weight) + ` ${t('common.kg')}`
                              : "--"}
                          </span>
                        </td>
                        <td className="text-center"> {item.weight_device_name ? item.weight_device_name : '--'}</td>
                        <td className="text-center">
                          <span
                            className={`table-link ${role === 4 ? 'admin-table-link' : ''}`}
                            onClick={() =>
                              setModal({
                                measurement: true,
                                member: item.id,
                                chartName: "Height",
                                gender: item.gender,
                                parent: item.parent,
                                dob: item?.dob,
                                name: item.name,
                              })
                            }
                          >
                            {item?.latest_height
                              ? formatMeasurement(item.latest_height) + ` ${t('common.cm')}`
                              : "--"}
                          </span>
                        </td>
                        <td className="text-center">
                          <span>
                            {item?.latest_head_circumference
                              ? formatMeasurement(item.latest_head_circumference) + ` ${t('common.cm')}`
                              : "--"}
                          </span>
                        </td>
                        <td className={`text-center ${role === 4 ? 'text-capitalize' : ''}`}>
                          <span>
                            {item?.blood_group ? item.blood_group : "--"}
                          </span>
                        </td>
                        <td className="text-center">
                          <span
                            onClick={() =>
                              setMessage({
                                show: true,
                                description: true,
                                title: `${item.name}'s Description`,
                                title: `${item.name}${t('common.possessive_suffix')} ${t('table.description')}`,
                                message: item.description,
                              })
                            }
                            className={`table-link ${role === 4 ? 'text-tmAquaDgreen admin-table-link' : 'text-tmBlue'}`}
                          >
                            <i
                              className="fa-solid fa-file-lines"
                              toggle="tooltip"
                              placement="top"
                              title={t('table.description')}
                            />
                          </span>
                        </td>
						{role !== 4 && <>
              <td className="text-center">
						  <Link
                            className={`table-link ${role === 4 ? 'text-tmAquaDgreen admin-table-link' : 'text-tmBlue'}`}
                            onClick={() =>
                              setModal({
                                addInfo: true,
                                member: item.id,
                                name: item.name
                              })
                            }
							>
							<i className="ri-add-box-fill align-middle fw-normal"></i>
                          </Link>
						</td>
            </>}
                        {/*<td className="text-center"><span className="table-link" onClick={()=>setModal({chart:true,member:item.id,name:item.name,chartName:3,parent:item.parent,type:'Temperature'})}>{item?.latest_temperature ? item?.latest_temperature +' C°' : '--'}</span></td>
						<td className="text-center"><span className="table-link" onClick={()=>setModal({chart:true,member:item.id,name:item.name,chartName:1,parent:item.parent,type:'Heart rate'})}>{item?.latest_heartrate ? item?.latest_heartrate +'(bpm)' : '--'}</span></td>
						<td className="text-center"><span className="table-link" onClick={()=>setModal({chart:true,member:item.id,name:item.name,chartName:2,parent:item.parent,type:'Blood Glucose'})}>{item?.latest_bloodglucose ? item?.latest_bloodglucose +'(mg/dL)' : '--'}</span></td>*/}
                      </tr>
                    ))}
                  {data.length === 0 && !isLoading && (
                    <tr>
                      <td colSpan="11" className="text-center">
                        {t('common.noRecord')}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/*End Table*/}

        {/*Pagination*/}
        <div className="row my-3">
          <div className="col-xxl-12 d-flex justify-content-center">
            {data.length !== 0 && (
              <Pagination
                page={request.page}
                handlePaginate={handlePaginate}
                total={count}
              />
            )}
          </div>
        </div>
        {/*End Pagination*/}
      </section>
      {/*End Page Content Section*/}
    </main>
  );
}

export default Dashboard;
